import React, { useEffect, useState } from "react";
import { Form, Input, Col, Divider, Upload, Icon, DatePicker } from 'antd';
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";


const { forwardRef, useRef, useImperativeHandle } = React;
export const LCBForm = forwardRef((props, ref) => {
    const [form] = Form.useForm();
    const [getDate, setgetValue] = useState('');


    useEffect(() => {
        dayjs.extend(weekday);
        dayjs.extend(localeData);
        dayjs.locale("en");
        dayjs.locale("vi");
        form.resetFields();
        
        setgetValue({getDate: new Date(props.data.value.ws_nemle_date)});
        form.setFieldsValue({
            getdate: dayjs(getDate.getDate, 'YYYY/MM/DD')
        });
        
      }, [props.data]);

    const handleNumChange = (event) =>{
        if (!/[0-9]/.test(event.key)) {
             event.preventDefault();
        }
    }

    useImperativeHandle(ref, () => ({
        onFinish(flag) {
          form.submit();
        },
    }));

    const onFinish = (values) => {
        if(values.getDate == undefined){
            values.getdate = getDate.getDate;
        }else{
            values.getdate = values.getdate._d;
        }
        props.onFormFinish(values)
    };

    return (
        <Form onFinish={onFinish} form={form} layout="vertical">
            <Col>
                <Form.Item name="getdate" label="प्राप्त दिनांक">
                    <DatePicker name='getdate' style={{ width: '100%' }} allowClear={false}/>
                </Form.Item>
            </Col>

            <Col>
                <Form.Item name="sno" label="नोंद क्रमाांक" rules={[{ required: true }]}>
                    <Input type='number' />
                </Form.Item>
            </Col>

            <Col>
                <Form.Item name="providername" label="कोणाकडे दिले (नाव)" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
            </Col>

            <Col>
                <Form.Item name="providermobilenumber" label="कोणाकडे दिले मोबाईल नंबर" rules={[{ required: true }]}>
                    <Input maxLength={10}  onKeyPress={handleNumChange}/>
                </Form.Item>
            </Col>
        </Form>

    );
});
